/**
 * URL interna segura para redirección post-login (evita open redirect).
 * Solo acepta rutas relativas que empiezan por un solo `/`.
 */
export function parseInternalReturnUrl(raw: string | null | undefined): string | null {
  if (raw == null || raw === '') {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return null;
  }
  return trimmed;
}
